import { filter, map } from 'rxjs/operators';

import { showModal } from '../../../app/reducers';
import { onUpdateAddressActionCreators } from '../../../config/address-lookup.config';
import { RootEpic } from '../../../store/epics';
import { addressResolved, lookupAddressSuccess } from '../reducers/addressLookup';

export const resolveAddressEpic: RootEpic = (action$, state$) => {
  return action$.pipe(
    filter(lookupAddressSuccess.match),
    map(({ payload: { status, address } }: ReturnType<typeof lookupAddressSuccess>) => {
      switch (status) {
        case 'verified':
          return addressResolved();
        case 'po_box':
          return showModal({
            type: 'address-post-office-box',
            context: null,
          });
        case 'cmra':
          return showModal({
            type: 'address-cmra',
            context: null,
          });
        case 'not_verified':
        case 'partial_missing_secondary':
        case 'partial_unverified_secondary':
          return showModal({
            type: 'address-unverified',
            context: {
              next: addressResolved(),
              status,
            },
          });
        case 'suggested':
          return showModal({
            type: 'address-similar',
            context: {
              suggestedAddressActions: [
                onUpdateAddressActionCreators[state$.value.addressLookup.type](address!),
                addressResolved(),
              ],
              originalAddressActions: [addressResolved()],
            },
          });
      }
    }),
  );
};
